//#region lib/components/FilterRail/criteria/criteria.ts
function e(e, t) {
	return {
		name: e.name,
		...e.qualifier === void 0 ? {} : { qualifier: e.qualifier },
		...e.operator === void 0 || e.operator === t.defaultOperator ? {} : { operator: e.operator }
	};
}
function t(e, t) {
	return e.name === t.name && e.qualifier === t.qualifier && e.operator === t.operator;
}
function n(e) {
	return e.reduce((e, t) => e + Math.max(t.values.length, 1), 0);
}
function r(e, n, r) {
	if (!r) return e.filter((e) => !t(e, n));
	if (e.some((e) => t(e, n))) {
		let i = !1;
		return e.flatMap((e) => t(e, n) ? i ? [] : (i = !0, [r]) : [e]);
	}
	let i = e.map((e) => e.name).lastIndexOf(n.name);
	return i === -1 ? [...e, r] : [
		...e.slice(0, i + 1),
		r,
		...e.slice(i + 1)
	];
}
//#endregion
//#region lib/components/FilterRail/logic/tree.ts
var i = {
	all: "All",
	any: "Any",
	none: "None"
}, a = {
	all: {
		connective: "and",
		negated: !1
	},
	any: {
		connective: "or",
		negated: !1
	},
	none: {
		connective: "or",
		negated: !0
	}
};
function o(e) {
	return e.negated ? "none" : e.connective === "and" ? "all" : "any";
}
function s(e) {
	return a[e];
}
function c() {
	return {
		kind: "group",
		connective: "and",
		negated: !1,
		terms: []
	};
}
function l(e) {
	return {
		kind: "criterion",
		...e
	};
}
function u(e) {
	return e.kind === "criterion" ? [e] : e.terms.flatMap(u);
}
function d(e, t) {
	let n = e;
	for (let e of t) {
		let r = n.terms[e];
		if (r.kind !== "group") throw Error(`No level at ${t.join(".")}`);
		n = r;
	}
	return n;
}
function f(e, t, n) {
	let r = (e, i) => {
		if (i === t.length) return n(e);
		let a = t[i], o = e.terms[a];
		if (o.kind !== "group") throw Error(`No level at ${t.join(".")}`);
		return {
			...e,
			terms: e.terms.map((e, t) => t === a ? r(o, i + 1) : e)
		};
	};
	return r(e, 0);
}
function p(e, t, n) {
	return f(e, t, (e) => ({
		...e,
		...s(n)
	}));
}
function m(e) {
	let [t] = e.terms;
	return e.terms.length === 1 && t.kind === "group" && o(t) === "none" ? {
		level: t,
		path: [0]
	} : {
		level: e,
		path: []
	};
}
function h(e, t) {
	let { level: n, path: r } = m(e);
	return t === "none" ? r.length ? e : {
		...e,
		connective: "and",
		terms: [{
			kind: "group",
			...s("none"),
			terms: e.terms
		}]
	} : {
		...e,
		connective: s(t).connective,
		terms: n.terms
	};
}
function g(e) {
	let t = (e) => {
		if (e.kind === "criterion") return e;
		if (e.negated && e.connective === "and") return e.terms.length === 1 ? {
			...e,
			connective: "or",
			terms: e.terms.map(t)
		} : {
			...e,
			connective: "or",
			negated: !1,
			terms: e.terms.map((e) => t(v(e)))
		};
		let n = e.terms.map(t);
		return n.every((t, n) => t === e.terms[n]) ? e : {
			...e,
			terms: n
		};
	};
	return t(e);
}
function _(e) {
	let t = (e) => {
		let n = e.terms.flatMap((e) => {
			if (e.kind === "criterion") return [e];
			let n = t(e);
			return n.terms.length ? [n] : [];
		});
		return n.length === e.terms.length && n.every((t, n) => t === e.terms[n]) ? e : {
			...e,
			terms: n
		};
	};
	return t(e);
}
function v(e) {
	return {
		...e,
		negated: !e.negated
	};
}
function y(e, t, n, r, i = []) {
	return f(e, t, (e) => ({
		...e,
		terms: [
			...e.terms.slice(0, n),
			...i,
			...e.terms.slice(n + r)
		]
	}));
}
function b(e, t, n) {
	return y(e, t, d(e, t).terms.length, 0, [n]);
}
function x(e, t) {
	return y(e, t.slice(0, -1), t[t.length - 1], 1);
}
function S(e) {
	let t = [], n = [];
	return e.terms.forEach((e, r) => {
		e.kind === "group" ? n.push({
			index: r,
			term: e
		}) : t.push({
			index: r,
			term: e
		});
	}), {
		criteria: t,
		groups: n
	};
}
function C(t, n) {
	if (t.connective !== "and" && t.terms.length > 1 || !t.terms.every((e) => e.kind === "criterion" || e.connective === "or" && !e.negated && w(e))) return !1;
	let r = t.terms.map((e) => u(e)[0].name);
	if (new Set(r).size !== r.length) return !1;
	let i = u(t).map((t) => JSON.stringify(e(t, n(t.name) ?? { defaultOperator: "" })));
	return new Set(i).size === i.length;
}
function w(e) {
	let t = new Set(e.terms.map((e) => e.kind === "criterion" ? e.name : null));
	return t.size === 1 && !t.has(null);
}
//#endregion
export { n as _, c as a, o as c, m as d, p as f, g, _ as h, u as i, S as l, y as m, b as n, C as o, h as p, l as r, d as s, i as t, x as u, r as v, e as y };

//# sourceMappingURL=tree-C5H1a4Gy.js.map